import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
})
export class ProductListComponent implements OnInit {
  constructor(
    private meta: Meta,
    private title: Title
  ) {}

  // TODO: Add an proper interface and move this to some kind of file or load it from backend
  private metaData = {
    title: 'Myescort.dk - Gratis sex annoncer for mænd og kvinder. Besøg os.',
    description:
      'Find escort, massage og BDSM sex annoncer på vores escortside. Nye opslag dagligt i hele Danmark. Besøg os og opret en annonce 100% gratis.',
  };

  ngOnInit(): void {
    this.meta.updateTag({ name: 'title', content: this.metaData.title });
    this.meta.updateTag({
      name: 'description',
      content: this.metaData.description,
    });
    this.meta.updateTag({ property: 'og:title', content: this.metaData.title });
    this.meta.updateTag({
      property: 'og:description',
      content: this.metaData.description,
    });
    this.title.setTitle(this.metaData.title);
  }
}
